import type { FC } from 'react';
import { PrivacyStyles as styles } from '../css/styles';
import { Helmet } from "react-helmet-async";

const Privacy: FC = () => {
    return (
        <>
            <Helmet>
                <title>Политика обработки персональных данных — First Klass</title>
                <meta name="description" content="Политика обработки персональных данных платформы First Klass (www.first-klass.ru)" />
            </Helmet>
            <div className={styles.privacyContainer}>
                <h1>Политика обработки персональных данных</h1>
                <p>
                    Настоящий документ определяет подход платформы <strong>First Klass</strong>,
                    расположенной по адресу <strong>www.first-klass.ru</strong> (далее — «Оператор»),
                    к обработке персональных данных пользователей и устанавливает меры по обеспечению
                    их безопасности в соответствии с требованиями Федерального закона от 27.07.2006
                    № 152-ФЗ «О персональных данных» (далее — «Закон о персональных данных»).
                </p>
                <p>
                    Оператор рассматривает защиту персональных данных как приоритетное условие
                    своей деятельности и принимает на себя обязательство соблюдать права граждан
                    на неприкосновенность частной жизни и конфиденциальность личных сведений.
                </p>
                <p>
                    Настоящая Политика распространяется на все персональные данные, которые
                    Оператор получает от посетителей и зарегистрированных пользователей
                    сайта www.first-klass.ru, а также мобильных приложений First Klass для
                    платформ iOS и Android (далее совместно — «Платформа»).
                </p>
                <p>
                    Платформой пользуются ученики, которые занимаются с преподавателем или
                    учебной организацией на First Klass. Учётные записи учеников создаёт
                    преподаватель или учебная организация; самостоятельная регистрация
                    учеников не предусмотрена.
                </p>

                <h2>1. Основные понятия</h2>
                <p>
                    В настоящей Политике используются следующие термины:
                </p>
                <p>
                    <strong>1.1. Автоматизированная обработка</strong> — обработка персональных данных
                    посредством средств вычислительной техники без участия человека.
                </p>
                <p>
                    <strong>1.2. Блокирование персональных данных</strong> — временная приостановка
                    операций с персональными данными, за исключением случаев, когда обработка
                    требуется для их уточнения.
                </p>
                <p>
                    <strong>1.3. Веб-сайт</strong> — совокупность программных средств, графических
                    и информационных материалов, доступных в сети Интернет по адресу www.first-klass.ru.
                </p>
                <p>
                    <strong>1.4. Информационная система персональных данных</strong> — совокупность
                    персональных данных, содержащихся в базах данных Оператора, и обеспечивающих
                    их обработку технических и информационных средств.
                </p>
                <p>
                    <strong>1.5. Обезличивание персональных данных</strong> — совокупность действий,
                    результатом которых становится невозможность установить принадлежность
                    персональных данных конкретному субъекту без привлечения дополнительных сведений.
                </p>
                <p>
                    <strong>1.6. Обработка персональных данных</strong> — любая операция или
                    совокупность операций, совершаемых с персональными данными: сбор, запись,
                    систематизация, накопление, хранение, уточнение, извлечение, использование,
                    передача, обезличивание, блокирование, удаление и уничтожение.
                </p>
                <p>
                    <strong>1.7. Оператор</strong> — юридическое лицо, организующее и осуществляющее
                    обработку персональных данных, определяющее цели, состав обрабатываемых данных
                    и совершаемые с ними операции. В рамках настоящей Политики Оператором выступает
                    платформа First Klass (www.first-klass.ru).
                </p>
                <p>
                    <strong>1.8. Персональные данные</strong> — любые сведения, прямо или косвенно
                    относящиеся к определённому или определяемому пользователю Веб-сайта.
                </p>
                <p>
                    <strong>1.9. Пользователь</strong> — любое физическое лицо, посещающее
                    Веб-сайт www.first-klass.ru или использующее его сервисы.
                </p>
                <p>
                    <strong>1.10. Предоставление персональных данных</strong> — раскрытие
                    персональных данных конкретному лицу или ограниченному кругу лиц.
                </p>
                <p>
                    <strong>1.11. Распространение персональных данных</strong> — действия,
                    направленные на раскрытие персональных данных неопределённому кругу лиц,
                    в том числе путём публикации в средствах массовой информации или в сети Интернет.
                </p>
                <p>
                    <strong>1.12. Уничтожение персональных данных</strong> — необратимое удаление
                    персональных данных из информационной системы и/или физических носителей,
                    исключающее возможность их дальнейшего восстановления.
                </p>

                <h2>2. Права и обязанности Оператора</h2>
                <p>2.1. Оператор вправе:</p>
                <ul>
                    <li>
                        запрашивать у субъектов персональных данных достоверные сведения и документы,
                        необходимые для их обработки;
                    </li>
                    <li>
                        продолжать обработку персональных данных без согласия субъекта в случаях,
                        предусмотренных Законом о персональных данных, даже после отзыва такого согласия;
                    </li>
                    <li>
                        самостоятельно определять перечень мер, необходимых для выполнения требований
                        Закона о персональных данных и связанных нормативных актов.
                    </li>
                </ul>
                <p>2.2. Оператор обязан:</p>
                <ul>
                    <li>
                        предоставлять субъекту персональных данных по его обращению информацию
                        об обработке его данных в доступной форме;
                    </li>
                    <li>
                        организовывать обработку персональных данных в полном соответствии с
                        действующим законодательством Российской Федерации;
                    </li>
                    <li>
                        рассматривать обращения и запросы субъектов персональных данных и их
                        законных представителей в установленные законом сроки;
                    </li>
                    <li>
                        обеспечивать открытый доступ к актуальной версии настоящей Политики;
                    </li>
                    <li>
                        применять правовые, организационные и технические меры для защиты персональных
                        данных от незаконного или случайного доступа, изменения, блокирования,
                        копирования, распространения и уничтожения;
                    </li>
                    <li>
                        прекращать обработку и уничтожать персональные данные в случаях и порядке,
                        предусмотренных Законом о персональных данных;
                    </li>
                    <li>
                        исполнять иные обязанности, предусмотренные действующим законодательством.
                    </li>
                </ul>

                <h2>3. Права и обязанности субъектов персональных данных</h2>
                <p>3.1. Пользователи как субъекты персональных данных вправе:</p>
                <ul>
                    <li>
                        получать от Оператора информацию об обработке своих персональных данных
                        в случаях и порядке, предусмотренных Законом о персональных данных;
                    </li>
                    <li>
                        требовать уточнения, блокирования или уничтожения своих персональных данных,
                        если они являются неполными, устаревшими, недостоверными или более не
                        необходимы для заявленных целей обработки;
                    </li>
                    <li>
                        устанавливать условие предварительного согласия при обработке персональных
                        данных в целях маркетинга и продвижения товаров и услуг;
                    </li>
                    <li>
                        отозвать ранее выданное согласие на обработку персональных данных;
                    </li>
                    <li>
                        обжаловать действия или бездействие Оператора в уполномоченный орган
                        по защите прав субъектов персональных данных либо в судебном порядке;
                    </li>
                    <li>
                        реализовывать иные права, предусмотренные законодательством Российской Федерации.
                    </li>
                </ul>
                <p>3.2. Пользователи обязаны:</p>
                <ul>
                    <li>предоставлять Оператору достоверные сведения о себе;</li>
                    <li>
                        своевременно сообщать Оператору об изменении ранее предоставленных
                        персональных данных.
                    </li>
                </ul>
                <p>
                    3.3. Лица, передавшие Оператору заведомо ложные сведения или персональные
                    данные других субъектов без их согласия, несут ответственность в соответствии
                    с законодательством Российской Федерации.
                </p>

                <h2>4. Состав обрабатываемых персональных данных</h2>
                <p>4.1. Оператор обрабатывает следующие категории персональных данных Пользователей:</p>
                <ul>
                    <li>фамилия, имя, отчество;</li>
                    <li>адрес электронной почты;</li>
                    <li>номер контактного телефона;</li>
                    <li>
                        учебные материалы, которые Пользователь самостоятельно вводит при
                        выполнении заданий: письменные ответы, домашние работы, ответы в тестах;
                    </li>
                    <li>
                        аудиозаписи устных ответов, которые Пользователь создаёт при выполнении
                        заданий по говорению в мобильном приложении;
                    </li>
                    <li>
                        данные об обучении, формируемые в процессе использования Платформы:
                        результаты и баллы тестов, оценки за домашние работы, посещаемость
                        занятий, журнал занятий, полученные награды;
                    </li>
                    <li>
                        технические данные: IP-адрес (фиксируется в журналах сервера и сервисом
                        Яндекс.Метрика при наличии согласия), тип и версия браузера, данные файлов
                        cookie, информация об устройстве и операционной системе.
                    </li>
                </ul>
                <p>
                    4.2. Оператор не осуществляет обработку специальных категорий персональных данных,
                    затрагивающих расовую или национальную принадлежность, политические взгляды,
                    религиозные или философские убеждения, состояние здоровья и интимную жизнь Пользователей.
                </p>
                <p>4.3. Обработка персональных данных осуществляется следующими способами:</p>
                <ul>
                    <li>автоматизированная обработка с использованием вычислительных систем;</li>
                    <li>неавтоматизированная обработка без применения средств автоматизации;</li>
                    <li>смешанная обработка с сочетанием указанных методов.</li>
                </ul>
                <p>
                    4.4. Обработка персональных данных осуществляется исключительно при наличии
                    согласия Пользователя, за исключением случаев, когда такая обработка допускается
                    законодательством Российской Федерации без согласия субъекта.
                </p>
                <p>
                    4.5. Пользователь самостоятельно принимает решение о предоставлении своих
                    персональных данных и выражает согласие добровольно, в своих интересах.
                </p>
                <p>
                    4.6. Передача персональных данных третьим лицам осуществляется исключительно
                    на основании договора об обработке персональных данных и/или согласия Пользователя,
                    если иное не предусмотрено законодательством. Получатели данных обязаны соблюдать
                    принципы и правила, установленные законодательством и настоящей Политикой.
                </p>
                <p>
                    4.7. По всем вопросам, связанным с обработкой персональных данных, Пользователь
                    вправе обратиться к Оператору по адресу электронной почты{' '}
                    <a href="mailto:privacy@first-klass.ru">privacy@first-klass.ru</a>{' '}
                    или через форму обратной связи на сайте. В обращении необходимо
                    указать сведения, позволяющие идентифицировать заявителя. При обращении через
                    представителя к запросу должна быть приложена доверенность или иной документ,
                    подтверждающий полномочия.
                </p>
                <p>
                    4.8. Мобильное приложение запрашивает доступ к микрофону устройства
                    исключительно для записи устного ответа при выполнении задания по говорению.
                    Запись загружается на серверы Оператора и становится доступна только
                    преподавателю Пользователя и учебной организации, через которую Пользователь
                    зачислен. Аудиозаписи не используются для идентификации по голосу, не
                    передаются иным третьим лицам и не используются в рекламных целях. Пользователь
                    вправе отказать в доступе к микрофону или отозвать его в настройках устройства;
                    в этом случае задания по говорению будут недоступны, а остальные функции
                    приложения продолжат работать.
                </p>
                <p>
                    4.9. Учебные материалы, аудиозаписи и данные об обучении Пользователя доступны
                    в рамках Платформы только его преподавателю и учебной организации, через
                    которую он зачислен, и не раскрываются иным третьим лицам. Пользователь вправе
                    в любой момент удалить свою учётную запись вместе с указанными данными
                    непосредственно в приложении (раздел «Профиль» → «Удалить аккаунт»); удаление
                    подтверждается по ссылке из письма.
                </p>

                <h2>5. Принципы обработки персональных данных</h2>
                <p>
                    5.1. Обработка персональных данных осуществляется на законной и справедливой основе.
                </p>
                <p>
                    5.2. Сбор и обработка персональных данных ограничиваются конкретными, заранее
                    установленными и законными целями. Обработка данных в целях, несовместимых
                    с теми, ради которых они были собраны, не допускается.
                </p>
                <p>
                    5.3. Не допускается объединение баз данных, содержащих персональные данные,
                    обработка которых осуществляется в несовместимых целях.
                </p>
                <p>
                    5.4. Обработке подлежат только те персональные данные, которые соответствуют
                    заявленным целям. Избыточный сбор данных сверх необходимого не допускается.
                </p>
                <p>
                    5.5. Оператор принимает меры для обеспечения точности, достаточности и
                    актуальности обрабатываемых данных применительно к целям их обработки,
                    в том числе своевременно удаляет или уточняет неполные и недостоверные сведения.
                </p>
                <p>
                    5.6. Хранение персональных данных осуществляется в форме, позволяющей
                    идентифицировать субъекта, не дольше, чем этого требуют цели обработки,
                    если более длительный срок не установлен федеральным законом или договором.
                    По достижении целей обработки данные уничтожаются или обезличиваются.
                </p>

                <h2>6. Цели обработки персональных данных</h2>
                <p>6.1. Персональные данные Пользователей обрабатываются в следующих целях:</p>
                <ul>
                    <li>
                        предоставление Пользователю доступа к сервисам, материалам и функционалу
                        Платформы First Klass;
                    </li>
                    <li>
                        заключение, исполнение и прекращение договорных отношений с Пользователем;
                    </li>
                    <li>
                        направление сервисных и информационных уведомлений, связанных с использованием
                        Платформы, а также ответы на запросы Пользователей;
                    </li>
                    <li>
                        рассылка информационных материалов при наличии соответствующего согласия Пользователя;
                    </li>
                    <li>
                        мониторинг и улучшение качества работы Платформы, персонализация
                        пользовательского опыта и разработка новых функций;
                    </li>
                    <li>
                        сбор и анализ обезличенной статистики с целью оптимизации работы сайта
                        и повышения удобства его использования.
                    </li>
                </ul>
                <p>
                    6.2. Обезличенные данные, получаемые посредством аналитических инструментов,
                    применяются исключительно для изучения поведения Пользователей на сайте
                    и улучшения его содержания и структуры.
                </p>

                <h2>7. Правовые основания обработки персональных данных</h2>
                <p>7.1. Обработка персональных данных Оператором осуществляется на основании:</p>
                <ul>
                    <li>Конституции Российской Федерации;</li>
                    <li>Гражданского кодекса Российской Федерации;</li>
                    <li>
                        Федерального закона от 27.07.2006 № 149-ФЗ «Об информации, информационных
                        технологиях и о защите информации»;
                    </li>
                    <li>Федерального закона от 07.07.2003 № 126-ФЗ «О связи»;</li>
                    <li>Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных»;</li>
                    <li>
                        Указа Президента РФ от 06.03.1997 № 188 «Об утверждении перечня сведений
                        конфиденциального характера»;
                    </li>
                    <li>
                        Постановления Правительства РФ от 01.11.2012 № 1119 «Об утверждении требований
                        к защите персональных данных при их обработке в информационных системах
                        персональных данных»;
                    </li>
                    <li>
                        Приказа Роскомнадзора от 05.09.2013 № 996 «Об утверждении требований
                        и методов по обезличиванию персональных данных»;
                    </li>
                    <li>
                        Приказа ФСТЭК России от 18.02.2013 № 21 «Об утверждении состава и содержания
                        организационных и технических мер по обеспечению безопасности персональных
                        данных при их обработке в информационных системах персональных данных»;
                    </li>
                    <li>согласия Пользователя на обработку персональных данных;</li>
                    <li>
                        иных нормативных актов, допускающих обработку персональных данных без
                        согласия субъекта в установленных законом случаях.
                    </li>
                </ul>
                <p>
                    7.2. Оператор обрабатывает персональные данные Пользователя только в том случае,
                    если они были самостоятельно предоставлены Пользователем — через регистрационные
                    формы на сайте www.first-klass.ru или путём направления сообщения Оператору.
                    Заполняя указанные формы, Пользователь подтверждает своё согласие с настоящей Политикой.
                </p>
                <p>
                    7.3. Согласие на обработку персональных данных выражается субъектом свободно,
                    осознанно и в собственных интересах.
                </p>

                <h2>8. Условия обработки персональных данных</h2>
                <p>
                    8.1. Обработка персональных данных осуществляется при наличии явного согласия
                    субъекта персональных данных, выраженного в установленной форме.
                </p>
                <p>
                    8.2. Обработка персональных данных допускается в объёме, необходимом для
                    исполнения договора, стороной или выгодоприобретателем по которому является
                    субъект персональных данных, а также для заключения такого договора по его
                    инициативе.
                </p>
                <p>
                    8.3. Обработка персональных данных может осуществляться в целях защиты законных
                    интересов Оператора или третьих лиц при условии, что при этом не ущемляются
                    права и свободы субъекта персональных данных.
                </p>

                <h2>9. Порядок сбора, хранения, передачи и иных видов обработки</h2>
                <p>
                    9.1. Безопасность персональных данных обеспечивается путём реализации комплекса
                    правовых, организационных и технических мер, отвечающих требованиям действующего
                    законодательства в области защиты персональных данных.
                </p>
                <p>
                    9.2. Оператор предпринимает все разумные меры для предотвращения доступа к
                    персональным данным Пользователей со стороны неуполномоченных лиц.
                </p>
                <p>
                    9.3. Персональные данные Пользователей не передаются третьим лицам, за
                    исключением случаев, прямо предусмотренных действующим законодательством
                    Российской Федерации, либо при наличии явного согласия субъекта на такую
                    передачу для исполнения гражданско-правового договора.
                </p>
                <p>
                    9.4. При обнаружении неточностей в персональных данных Пользователь вправе
                    уточнить их самостоятельно в личном кабинете на Платформе либо направив
                    письменное обращение Оператору с пометкой «Уточнение персональных данных».
                </p>
                <p>
                    9.5. Срок обработки персональных данных определяется достижением целей, ради
                    которых они были собраны, если иной срок не установлен договором или
                    законодательством. Пользователь вправе в любой момент отозвать своё согласие
                    на обработку персональных данных, направив соответствующее уведомление Оператору
                    с пометкой «Отзыв согласия на обработку персональных данных».
                </p>
                <p>
                    9.6. Персональные данные хранятся в форме, позволяющей идентифицировать субъекта,
                    не дольше, чем это необходимо для достижения целей обработки, если более
                    длительный срок хранения не предусмотрен законом или договором.
                </p>
                <p>
                    9.7. Основаниями для прекращения обработки персональных данных являются:
                    достижение заявленных целей обработки, истечение срока действия согласия
                    субъекта, отзыв согласия, а также выявление факта незаконной обработки.
                </p>

                <h2>10. Операции, осуществляемые с персональными данными</h2>
                <p>
                    10.1. В рамках своей деятельности Оператор выполняет следующие операции
                    с персональными данными: сбор, запись, систематизацию, накопление, хранение,
                    уточнение (обновление, изменение), извлечение, использование, передачу,
                    обезличивание, блокирование, удаление и уничтожение.
                </p>
                <p>
                    10.2. Оператор осуществляет как автоматизированную, так и неавтоматизированную
                    обработку персональных данных, в том числе с передачей информации по
                    информационно-телекоммуникационным сетям.
                </p>

                <h2>11. Конфиденциальность персональных данных</h2>
                <p>
                    11.1. Оператор и все лица, получившие доступ к персональным данным в рамках
                    своих полномочий, обязаны не раскрывать их третьим лицам и не допускать их
                    распространения без согласия субъекта, если иное прямо не предусмотрено
                    федеральным законодательством.
                </p>
                <p>
                    11.2. Условия конфиденциальности сохраняют силу в течение всего срока
                    обработки персональных данных, а также после прекращения такой обработки
                    в случаях, установленных законодательством.
                </p>

                <h2>12. Использование файлов cookie и аналитических инструментов</h2>
                <p>
                    12.1. Веб-сайт www.first-klass.ru использует файлы cookie — небольшие
                    текстовые файлы, сохраняемые на устройстве Пользователя браузером при
                    посещении сайта. Cookie позволяют Оператору распознавать Пользователя
                    при повторных визитах и обеспечивать корректную работу сайта.
                </p>
                <p>
                    12.2. Пользователь вправе отключить сохранение cookie в настройках браузера.
                    Следует учитывать, что отключение cookie может повлиять на доступность
                    отдельных функций Платформы.
                </p>
                <p>
                    12.3. Для анализа посещаемости и поведения Пользователей на сайте Оператор
                    использует сервис веб-аналитики <strong>Яндекс.Метрика</strong>, предоставляемый
                    ООО «ЯНДЕКС» (Россия). Яндекс.Метрика собирает обезличенные данные о действиях
                    Пользователей на Платформе, в том числе: просмотры страниц, переходы между
                    разделами, время нахождения на странице, тепловые карты кликов и скроллинга,
                    а также записи пользовательских сессий. Указанные данные используются
                    исключительно в целях улучшения функциональности и удобства Платформы.
                </p>
                <p>
                    12.4. Аналитические cookie-файлы Яндекс.Метрики устанавливаются только при
                    наличии явного согласия Пользователя, выраженного через баннер cookie-согласия
                    при первом посещении Платформы. Пользователь вправе в любой момент отозвать
                    согласие, выбрав «Только необходимые» в баннере при его повторном отображении,
                    либо установив{' '}
                    <a
                        href="https://yandex.ru/support/metrica/general/opt-out.html"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        браузерное расширение для отказа от Яндекс.Метрики
                    </a>.
                </p>
                <p>
                    12.5. Данные, собираемые Яндекс.Метрикой, обрабатываются в соответствии
                    с{' '}
                    <a
                        href="https://yandex.ru/legal/confidential/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Политикой конфиденциальности Яндекса
                    </a>.
                    Оператор не передаёт Яндексу персональные данные Пользователей и не несёт
                    ответственности за обработку данных Яндексом на его стороне.
                </p>
                <p>
                    12.6. Мобильные приложения First Klass <strong>не используют</strong>
                    {' '}Яндекс.Метрику и иные сторонние сервисы аналитики, рекламы или
                    отслеживания и не собирают рекламный идентификатор устройства. Положения
                    настоящего раздела о файлах cookie и аналитических инструментах относятся
                    только к веб-сайту www.first-klass.ru.
                </p>

                <h2>13. Заключительные положения</h2>
                <p>
                    13.1. Настоящая Политика вступает в силу с момента её публикации на сайте
                    www.first-klass.ru и действует бессрочно до принятия новой редакции.
                </p>
                <p>
                    13.2. Оператор вправе вносить изменения в настоящую Политику в одностороннем
                    порядке. Все изменения вступают в силу с момента их публикации на сайте.
                    Продолжение использования Платформы после публикации изменений означает
                    согласие Пользователя с обновлённой редакцией Политики.
                </p>
                <p>
                    13.3. Актуальная версия Политики постоянно доступна в открытом доступе
                    по адресу: <strong>www.first-klass.ru</strong>.
                </p>
                <p>
                    13.4. По всем вопросам, связанным с применением настоящей Политики,
                    Пользователь вправе обратиться к Оператору по адресу{' '}
                    <a href="mailto:privacy@first-klass.ru">privacy@first-klass.ru</a>{' '}
                    или через форму обратной связи на сайте www.first-klass.ru.
                </p>
                <p>
                    <strong>Редакция от 31 августа 2026 г.</strong>
                </p>
            </div>
        </>
    );
};

export default Privacy;
